import React, {Component} from "react";
import {fbChatBoxDashboardUrl} from '../../config';
import Core from '../../core';
import {Card, OptionList, Icon} from '@shopify/polaris';
import {Redirect} from "react-router-dom";
import './dashboard-navigator.scss';

class DashboardNavigator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectMenuAction: '',
      redirectApp: '',
      navigators: []
    };
  }

  onMenuChange = (updated) => {
    this.setState({redirectMenuAction: updated[0]});
  };

  onRedirectApp = (appName) => {
    this.setState({redirectApp: appName});
  };

  componentDidMount() {
    const appName = this.props.appName;
    switch (appName) {
      case 'coupon-box':
        this.setState({
          navigators: [
            {label: 'Coupon code', value: '/'},
            {label: 'Subscribers', value: '/subscribers'}
          ]
        });
        break;
      case 'facebook-chat':
        this.setState({
          navigators: [
            {label: 'Account', value: '/account'},
            {label: 'Basic Settings', value: '/basic-settings'},
            {label: 'Chatbot', value: '/chat-bot'}
          ]
        });
        break;
      default:
        break;
    }
  }

  render() {
    const pathname = window.location.pathname;
    if (this.state.redirectMenuAction && this.state.redirectMenuAction !== pathname) {
      return <Redirect to={this.state.redirectMenuAction} push/>;
    } else {
      // console.log('path name equal, not redirect anymore!');
    }

    switch (this.state.redirectApp) {
      case 'facebook-chat':
        const appUrl = `${fbChatBoxDashboardUrl}?shop=${Core.getUrlParams('shop')}`;
        window.ShopifyApp.remoteRedirect(appUrl);
        break;
      default:
        break;
    }

    return (
      <div className="col-md-3 col-12 col-xs-12 remove-padding" id="wrap-autoketing-navigator">
        <div id="autoketing-navigator">
          <Card>
            <OptionList
              title="Menu"
              onChange={(updated) => this.onMenuChange(updated)}
              sections={[
                {
                  options: this.state.navigators,
                }
              ]}
              selected={'byward_market'}
            />
          </Card>
          <Card>
            <ul className="Polaris-OptionList">
              <li className="Polaris-OptionList__Options">
                <p className="Polaris-OptionList__Title" role="presentation">My Apps</p>
                <ul className="Polaris-OptionList__Options" id="wrap-app-menu">
                  <li className="Polaris-OptionList-Option" tabIndex="-1">
                    <button type="button" onClick={() => this.onRedirectApp('facebook-chat')}
                            className="Polaris-OptionList-Option__SingleSelectOption">
                      <span className="icon"> <Icon color="green" source="circleChevronDown"/></span>
                      <span className="text">Facebook Chat Box</span>
                    </button>
                  </li>
                  <li className="Polaris-OptionList-Option" tabIndex="-1">
                    <button type="button"
                            className="Polaris-OptionList-Option__SingleSelectOption">
                      <span className="icon"> <Icon color="green" source="circleChevronDown"/></span>
                      <span className="text">Currency Convert</span>
                    </button>
                  </li>
                  <li className="Polaris-OptionList-Option" tabIndex="-1">
                    <button type="button"
                            className="Polaris-OptionList-Option__SingleSelectOption">
                      <span className="icon"> <Icon color="green" source="circleChevronDown"/></span>
                      <span className="text">Sales Pop Master</span>
                    </button>
                  </li>
                </ul>
              </li>
            </ul>
          </Card>
        </div>
      </div>
    )
  }
}

export default DashboardNavigator
